"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mammo = void 0;
exports.mammo = {
    id: 75473,
    caseRuns: [
        {
            case_id: 75473,
            cci_edit_indicator: null,
            process_instance_guid: "",
            case_uid: "123",
            cci_editor_issues: null,
            facility: "HFM",
            claims_edit_indicator: null,
            claims_edit_enabled_indicator: null,
            claims_editor_issues: null,
            claims_editor_payer_id: "053",
            claims_editor_payer_name: null,
            primary_process_indicator: true,
            case_status: "Automated",
            process_instance_id: 76287,
            process_status: "Done",
            run_type: "prediction",
            source_type: "HL7",
            service_line: "Radiology",
            tenant_code: "MGH",
            tenant_name: "Massachusetts General Hospital",
            health_system_code: "PHS",
            patient_id: 63231,
            patient_name: "XXXXXX, XXXXXX",
            phase: "TESTING",
            date_of_birth: "1979-01-26",
            patient_gender: "F",
            patient_identifier: {
                number: "88888888",
                issuer: "EPIC",
                type: "MRN"
            },
            visit_number: {
                number: "33114624822342",
                issuer: "CMX",
                type: "VISIT_NUMBER"
            },
            account_number: {
                number: "6125400562234",
                issuer: null,
                type: null
            },
            patient_class: "OUTPATIENT",
            patient_type: null,
            reason_for_visit: "breast tenderness ",
            primary_insurance: null,
            primary_insurance_category: null,
            encounter_identifier: {
                number: "033301-2020-06-19-231286",
                issuer: "CMX",
                type: "ENCOUNTER_NUMBER"
            },
            exam_description: "BI US BREAST LIMITED (RIGHT)",
            point_of_care: "MGH_IMGUSNS",
            place_of_service: "MGDAN",
            order_control: "RE",
            order_number: {
                number: "686952222",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_placer_number: {
                number: "686957279",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_filler_number: {
                number: "E15996038",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            ordering_provider_name: "JONES, ALEXIS C",
            ordering_provider_specialty: null,
            ordering_provider_number: {
                number: "1275502643",
                issuer: "NPI",
                type: "NPI"
            },
            primary_clinical_identifier: {
                number: "E15006038",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            division: "MGDAN",
            exam_code: "US.BI.BSTLTD/R",
            body_region: "Chest",
            procedure_type: "Ultrasound",
            procedure_type_category: "US",
            date_of_service: "2020-06-19",
            exam_date: "2020-06-19",
            rules: null,
            result_status: "F",
            billing_location: "MGDAN",
            billing_area: null,
            billing_provider_specialty: null,
            billing_provider_name: "CONTE, RHONDA J",
            billing_provider_number: {
                number: "1750589495",
                issuer: "NPI",
                type: "NPI"
            },
            billing_provider_assistant_name: null,
            billing_provider_assistant_number: null,
            scheduling_department: null,
            placer_field_2: null,
            work_queue_name: "US BREAST",
            custom_values: {
                resource_code: "1115",
                scheduling_department_name: "MGH IMG US NS",
                resource_name: "MGH US1NS"
            },
            mappings: [
                {
                    name: "exam_code",
                    value: "US.BI.BSTLTD/R",
                    mapped_values: [
                        {
                            name: "body_region",
                            value: "Chest",
                            values: []
                        },
                        {
                            name: "procedure_type",
                            value: "Ultrasound",
                            values: []
                        },
                        {
                            name: "work_queue_name",
                            value: "US BREAST",
                            values: []
                        },
                        {
                            name: "procedure_type_category",
                            value: "US",
                            values: []
                        }
                    ]
                }
            ],
            artifacts: [
                {
                    artifact_id: 254601,
                    type: "PROCESSED",
                    identifier: "76287",
                    procedures: {
                        automate: true,
                        uuid: "self-applied",
                        evidence: [],
                        codes: [
                            {
                                procedure_name: null,
                                procedure_code: "76642",
                                uuid: "self-applied",
                                type: null,
                                units: 1,
                                automate: true,
                                evidence: [],
                                modifiers: {
                                    confidence: 0,
                                    automate: false,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            uuid: "wejrkj",
                                            automate: false,
                                            confidence: 1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: [
                                        {
                                            diagnosis_code: "N64.4",
                                            automate: false,
                                            confidence: 0.95,
                                            uuid: "self applied garbage",
                                            type: null,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                confidence: 1,
                                used: true
                            }
                        ],
                        confidence: 1
                    },
                    modifiers: {
                        confidence: 0.97,
                        automate: true,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.95,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 249906,
                    type: "CLINICAL",
                    identifier: null,
                    procedures: {
                        automate: false,
                        uuid: "self-applied",
                        evidence: [],
                        codes: [
                            {
                                procedure_name: null,
                                procedure_code: "76642",
                                uuid: "self-applied",
                                type: null,
                                units: 0,
                                automate: false,
                                evidence: [],
                                modifiers: {
                                    confidence: 0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                },
                                confidence: -1,
                                used: false
                            },
                            {
                                procedure_name: null,
                                procedure_code: "77066",
                                uuid: "self-applied2",
                                type: null,
                                units: 0,
                                automate: false,
                                evidence: [],
                                modifiers: {
                                    confidence: 0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                },
                                confidence: -1,
                                used: false
                            }
                        ],
                        confidence: -1
                    },
                    modifiers: {
                        confidence: -1,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 254588,
                    type: "PREDICTION",
                    identifier: "76287",
                    procedures: {
                        automate: true,
                        uuid: "self-applied",
                        evidence: [],
                        codes: [
                            {
                                procedure_name: null,
                                procedure_code: "76642",
                                uuid: "self-applied",
                                type: null,
                                units: 1,
                                automate: false,
                                evidence: [],
                                modifiers: {
                                    confidence: 0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                },
                                confidence: 0.99,
                                used: true
                            }
                        ],
                        confidence: 0.99
                    },
                    modifiers: {
                        confidence: 0.97,
                        automate: true,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "RT",
                                automate: false,
                                confidence: 0.97,
                                uuid: "self-applied",
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 0.95,
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "N64.4",
                                automate: false,
                                confidence: 0.95,
                                uuid: "self-applied",
                                type: null,
                                evidence: [],
                                used: true
                            }
                        ]
                    }
                },
                {
                    artifact_id: 249911,
                    type: "MAPPED",
                    identifier: null,
                    procedures: {
                        automate: false,
                        uuid: "self-applied",
                        evidence: [],
                        codes: [
                            {
                                procedure_name: null,
                                procedure_code: "76642",
                                type: null,
                                units: 0,
                                automate: false,
                                uuid: "self-applied",
                                evidence: [],
                                modifiers: {
                                    confidence: 0,
                                    automate: false,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            automate: false,
                                            uuid: "self-applied",
                                            confidence: -1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                },
                                confidence: -1,
                                used: true
                            }
                        ],
                        confidence: -1
                    },
                    modifiers: {
                        confidence: -1,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                }
            ],
            notes: [
                {
                    document_id: 79962,
                    description: null,
                    content: "HISTORY:\n 46 year old female seen for diagnostic evaluation of pain in the right breast.\n  \n PROCEDURE:\n Diagnostic mammographic and tomosynthesis views were obtained. Computer-aided detection was utilized by the radiologist in the interpretation of this examination.\n  \n BILATERAL MAMMOGRAM:\n The present study is compared to previous imaging.\n There are scattered fibroglandular densities.\n  \n There is an area of prior needle biopsy in the left breast.\n  \n No suspicious masses, calcifications or other abnormalities are seen in either breast.\n  \n Specifically, there is no focal or suspicious sonographic correlate for the area of clinical concern in the lateral left breast as indicated by a triangular tissue marker.\n  \n BREAST ULTRASOUND\n Targeted sonographic evaluation is performed of the right breast in the area of clinical concern as indicated by the patient.\n  \n There is no focal or suspicious sonographic correlate for the area of clinical concern in the lateral right breast.\n  \n IMPRESSION:\n No mammographic or sonographic correlate for the area of clinical concern in the right breast. Need for additional imaging or intervention should be based on follow-up clinical assessment.\n  \n No mammographic evidence of malignancy in either breast.\n  \n BI-RADS Category 2: Benign Finding\n  \n  \n \n Interpreted by:\n Rhonda J Conte, MD\n \n Signed by:\n Rhonda J Conte, MD\n 6/19/20\n \n Final result\n",
                    filename: null,
                    type: "RAW",
                    id: null
                }
            ],
            case_created_datetime: "2020-06-19 12:50:20 UTC",
            process_instance_created_datetime: "2020-06-19 12:50:20 UTC",
            exclusion_datetime: null,
            prediction_start_datetime: null,
            added_to_batch_datetime: "2020-06-19 12:52:29 UTC",
            response_from_batch_datetime: null,
            prediction_end_datetime: "2020-06-19 15:25:28 UTC",
            automation_decision_datetime: "2020-06-19 15:25:31 UTC",
            send_to_coder_datetime: null,
            received_from_coder_datetime: null,
            send_to_billing_datetime: "2020-06-19 15:25:32 UTC",
            process_instance_completed_datetime: "2020-06-19 15:25:32 UTC",
            case_completed_datetime: "2020-06-19 15:25:32 UTC",
            patient_age: 46,
            prevent_billing_indicator: false,
            prevent_send_to_coder_indicator: false,
            automated_indicator: false,
            route_to_predict: true,
            route_to_billing: true,
            route_to_qa: false,
            route_to_coder: false,
            pre_prediction_process_reason: null,
            post_prediction_process_reason: "Automate:High Confidence",
            automate_decision_reason: "PREDICTION",
            termination_indicator: false,
            study_indicator: false,
            automation_eligible: true,
            decoration: '{"Automate":["High Confidence"]}',
            process: null,
            rule_evaluation_results: []
        }
    ]
};
//# sourceMappingURL=mammo.js.map